<template>
<svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 16 18" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M15.3846 12.3077H13.2566L9.15446 6.15385H10.4615L11.0769 5.53846V0.615385L10.4615 0H5.53846L4.92308 0.615385V5.53846L5.53846 6.15385H6.84554L2.74338 12.3077H0.615385L0 12.9231V16.6154L0.615385 17.2308H4.30769L4.92308 16.6154V12.9231L4.30769 12.3077H4.224L8 6.64615L11.776 12.3077H11.6923L11.0769 12.9231V16.6154L11.6923 17.2308H15.3846L16 16.6154V12.9231L15.3846 12.3077ZM6.15385 4.92308V1.23077H6.15392V4.92302H9.84615V4.92308H6.15385ZM3.69231 13.5385V16H1.23077V16H3.69227V13.5385H3.69231ZM14.7692 16H12.3077V16H14.7691V13.5385H14.7692V16Z"
    :fill="fill"/>
</svg>
</template>

<script>
export default {
  props: {
    width: {
      type: [Number, String],
      default: 16
    },
    height: {
      type: [Number, String],
      default: 18
    },
    fill: {
      type: String,
      default: '#9CA6BA'
    }
  }
}
</script>
